import initRender from './js/frontend/render';
import initVideosBlock from './js/frontend/videos';
import initMenu from "./js/frontend/menu";

initRender();
initMenu();
initVideosBlock();
